import Request, { API } from '@/http/'
export function newTrack (pageName, featureName, type, action) {
  Request.getData(`${API.newTrack}/${pageName}/${featureName}/${type}/${action}`, {
    deviceNo: localStorage.getItem('deviceNo')
  })
}
export const $newTrack = newTrack
export default {
  install (Vue, options) {
    Vue.prototype.$newTrack = newTrack
  }
}
